import { getAccess } from '../callables/get-access.js';
function getAccessToVideo(ff, video) {
  return getAccess(ff, video.channelId, video.docId);
}
export { getAccessToVideo };
